'use client';

import { Box, Card, Flex, Heading, Stack, Text } from '@chakra-ui/react';
import { useLayoutEffect, useState } from 'react';

import { Link } from '@ui/link';

export default function Sumary() {
  const [sumary, setSumary] = useState<{ title: string; id: string }[]>();

  const [visibleSumaryItem, setVisibleSumaryItem] = useState<number>(0);

  const getSumary = () => {
    const downItems = [] as number[];
    document.querySelectorAll('article h2')?.forEach((h2, i) => {
      if (h2.getBoundingClientRect().bottom < window.innerHeight * 0.4) {
        downItems.push(i);
      }
    });
    setVisibleSumaryItem(downItems[downItems.length - 1] ?? null);
  };

  useLayoutEffect(() => {
    const titles = [] as { title: string; id: string }[];

    document.querySelectorAll('article h2')?.forEach((h2, i) => {
      if (h2.textContent && h2.textContent.trim().length > 0) {
        const id = `section_${i + 1}`;
        titles.push({
          id,
          title: h2.textContent,
        });
        // eslint-disable-next-line no-param-reassign
        h2.id = id;
      }
    });
    setSumary(titles);
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('scroll', getSumary);
    return () => window.removeEventListener('scroll', getSumary);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return sumary?.length ? (
    <Card.Root id="sumary" flex="0 1" overflowY="auto">
      <Card.Body>
        <Heading as="div" fontSize="md" mb="6">
          Sommaire
        </Heading>

        <Box as="nav" aria-label="Sommaire">
          <Stack
            as="ol"
            gap="4"
            css={{
              listStyle: 'none',
              padding: 0,
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '2px',
                left: '11px',
                width: '2px',
                height: 'calc(100% - 4px)',
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {sumary.map((elt, i) => (
              <Box as="li" key={elt.id}>
                <Link
                  href={`#${elt.id}`}
                  variant="plain"
                  display="flex"
                  alignItems="flex-start"
                  _hover={{
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    // letterSpacing: '-0.01em',
                  }}
                  color="primary.dark"
                  fontSize="lg"
                  lineHeight="1.1em"
                  fontWeight={visibleSumaryItem === i ? 'bold' : 'normal'}
                  transitionProperty="all"
                  transitionDuration="fast"
                >
                  <Flex
                    boxSize="6"
                    bgColor={visibleSumaryItem === i ? 'primary.dark' : 'primary.light'}
                    color={visibleSumaryItem === i ? 'cream.light' : 'primary.dark'}
                    borderRadius="full"
                    alignItems="center"
                    justifyContent="center"
                    fontWeight="bold"
                    mr="4"
                    flexShrink="0"
                    zIndex="1"
                    lineHeight="1"
                  >
                    {i + 1}
                  </Flex>
                  <Text as="span" textWrap="balance">
                    {elt.title}
                  </Text>
                </Link>
              </Box>
            ))}
          </Stack>
        </Box>
      </Card.Body>
    </Card.Root>
  ) : null;
}
